



































import { Vue, Component, Prop } from 'vue-property-decorator';
import IDropdown from '@/project/form/IDropdown';

@Component
export default class Dropdown extends Vue implements IDropdown {
    @Prop({ type: String, required: false })
    private buttonClass!: string;

    @Prop({ type: String, required: false, default: '' })
    private icon!: string;

    @Prop({ type: Boolean, required: false, default: false })
    private iconIsAfter!: boolean;

    @Prop({ type: Boolean, required: false, default: false })
    private positionRight!: boolean;

    private dropdownActive: boolean = false;

    private positionStyle: Partial<CSSStyleDeclaration> | null = null;
    private setPositionStyle() {
        const rect = this.$el.getBoundingClientRect();
        const parentRect = this.$el.parentElement!.getBoundingClientRect();
        const parentParentRect = this.$el.parentElement!.parentElement!.getBoundingClientRect();
        const minWidth = `${parentParentRect.width * 0.6}px`;
        const top = Math.abs(parentRect.top - rect.top);

        const direction = this.positionRight ? 'right' : 'left';

        this.positionStyle = {
            top: top + 'px',
            [direction]: '0',
            minWidth
        };
    }

    public openDropdown() {
        this.setPositionStyle();
        this.dropdownActive = true;
    }

    public closeDropdown() {
        this.dropdownActive = false;
        this.$emit('close');
    }

    get hasIconBefore(): boolean {
        return this.icon !== '' && !this.iconIsAfter;
    }

    get hasIconAfter(): boolean {
        return this.icon !== '' && this.iconIsAfter;
    }

    private handleClick() {
        this.$emit('click');

        if (!this.dropdownActive) {
            this.openDropdown();
        }
    }
}
